import {
  TextField,
  Button,
  Stack,
  IconButton,
  useMediaQuery,
  useTheme,
  Paper,
} from "@mui/material";
import { RootState } from "../redux/store";
import { useAppSelector, useAppDispatch } from "../hooks/hooks";
import AttachmentDrawer from "./AttachmentDrawer";
import CardGiftcardIcon from "@mui/icons-material/CardGiftcard";
import TokenIcon from "@mui/icons-material/Token";
import {
  closeNftSelectionDrawer,
  fetchNfts,
  openNftSelectionDrawer,
} from "../redux/nftSlice";
// import { openBuyGiftsDrawer } from "../redux/giftShoppingCartSlice";
import {
  fetchGiftBrands,
  setSelectGiftCardsDrawerOpen,
} from "../redux/giftBrandsSlice";
import SelectNftsDialog from "./SelectNftsDialog";
import SelectGiftsDialog from "./SelectGiftsDialog";
import { GiftBrand } from "../models/GiftBrand";

// Get width from environment variable with fallback (consistent with other components)
const MOBILE_APP_WIDTH = parseInt(
  process.env.REACT_APP_MOBILE_APP_WIDTH || "500"
);

interface MessageInputProps {
  message: string;
  onMessageChange: (value: string) => void;
  onSend: () => void;
  onAttachGift: () => void;
  onAttachNFT: () => void;
  onBuyGift: () => void;
}

export const MessageInput = ({
  message,
  onMessageChange,
  onSend,
  onAttachGift,
  onAttachNFT,
  onBuyGift,
}: MessageInputProps) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(`(max-width:${MOBILE_APP_WIDTH}px)`);
  const { selectedContact } = useAppSelector(
    (state: RootState) => state.chatList
  );
  const dispatch = useAppDispatch();

  return (
    <Paper
      sx={{
        p: isMobile ? 1 : 2,
        width: "100%",
        maxWidth: MOBILE_APP_WIDTH,
        margin: "auto",
        ...(isMobile && {
          maxWidth: "100%",
          borderRadius: 0,
          boxShadow: "none",
        }),
        ...(!isMobile && {
          borderRadius: 0,
          boxShadow: 0,
        }),
      }}
    >
      <Stack spacing={isMobile ? 1 : 2} direction="column">
        <TextField
          fullWidth
          size={isMobile ? "small" : "medium"}
          value={message}
          onChange={(e) => onMessageChange(e.target.value)}
          onKeyPress={(e) => e.key === "Enter" && onSend()}
          sx={{
            "& .MuiInputBase-root": {
              borderRadius: isMobile ? 4 : 2,
            },
          }}
        />
        <Stack direction="row" spacing={isMobile ? 1 : 2} alignItems="center">
          <Button
            variant="contained"
            onClick={onSend}
            fullWidth
            size={isMobile ? "small" : "medium"}
            sx={{
              borderRadius: isMobile ? 4 : 2,
              flex: isMobile ? 1 : undefined,
            }}
          >
            {isMobile ? "Send" : "Send Message"}
          </Button>
          {!selectedContact?.isGroup && (
            <>
              <IconButton
                onClick={async () => {
                  await dispatch(
                    fetchGiftBrands({ countryCode: "CA", currentPage: 1 })
                  );
                  dispatch(setSelectGiftCardsDrawerOpen(true));
                }}
                color="primary"
                size={isMobile ? "small" : "medium"}
              >
                <CardGiftcardIcon fontSize={isMobile ? "small" : "medium"} />
              </IconButton>
              <IconButton
                onClick={async () => {
                  await dispatch(fetchNfts());
                  dispatch(openNftSelectionDrawer());
                }}
                color="primary"
                size={isMobile ? "small" : "medium"}
              >
                <TokenIcon fontSize={isMobile ? "small" : "medium"} />
              </IconButton>
              <AttachmentDrawer />
              <SelectNftsDialog
                onSelect={(nft: any) => {
                  dispatch(closeNftSelectionDrawer());
                }}
              />
              <SelectGiftsDialog
                onSelect={(brand: GiftBrand) => {
                  dispatch(closeNftSelectionDrawer());
                }}
              />
            </>
          )}
        </Stack>
      </Stack>
    </Paper>
  );
};
